const state = {
    customer: {
        name: '',
        email: '',
    },
    invoice: {
        id: 1,
        items: [],
        dueDate: '',
        totalAmount: null,
        currency: null,
    },
    company: {
        name: '',
        address: '',
    },
    discountRate: {
        total: 1.0,
        cloudfront: {
            'US East (N. Virginia)': null,
            'Asia Pacific (Singapore)': null,
            'Asia Pacific (Sydney)': null,
            'Canada (Central)': null,
            'South America (São Paulo)': null,
            'Middle East (Bahrain)': null,
            'Africa (Cape Town)': null,
            'Asia Pacific (Tokyo)': null,
            'EU (Ireland)': null,
            'Asia Pacific (Mumbai)': null,
        },
    },
};
const getters = {
    getInvoiceItems({ invoice }) {
        let items = {};
        for (var serviceKey in invoice.items) {
            for (var regionKey in invoice.items[serviceKey]) {
                if (!items[serviceKey]) items[serviceKey] = {};
                items[serviceKey][regionKey] = invoice.items[serviceKey][
                    regionKey
                ].map((item) => {
                    item.Description =
                        item.line_item_line_item_description.replace(
                            'USD ',
                            '$'
                        );
                    if (item.Description.includes(' per ')) {
                        item.Description = item.Description.replace(
                            /.* per( \d+([,]\d+)*([.]\d+)?)?/g,
                            'per'
                        );
                    }
                    // uppercase first character
                    item.Description = item.Description.replace(
                        item.Description.charAt(0),
                        item.Description.charAt(0).toUpperCase()
                    );
                    item.line_item_unblended_rate = parseFloat(
                        item.line_item_unblended_rate
                    );
                    item.item_unblended_cost = parseFloat(
                        item.item_unblended_cost
                    );
                    if (
                        serviceKey === 'Amazon CloudFront' &&
                        (item.line_item_line_item_description.includes(
                            'Download bandwidth consumed'
                        ) ||
                            item.line_item_line_item_description.includes(
                                'SA-DataTransfer-Out-Bytes'
                            ) ||
                            item.line_item_line_item_description.includes(
                                'month data transfer out'
                            ) ||
                            item.line_item_line_item_description.includes(
                                'data transfer out ('
                            )) &&
                        state.discountRate.cloudfront[regionKey]
                    ) {
                        item.Price = state.discountRate.cloudfront[regionKey];
                        item.SubAmount = item.Price * item.item_usage_amount;
                    } else {
                        item.Price = null;
                        item.SubAmount = item.item_unblended_cost;
                    }
                    if (!item.tax) item.tax = 0;
                    return item;
                });
            }
        }
        return items;
        // }
    },
    getServiceSubtotal({ invoice }, { getInvoiceItems }) {
        const dict = getInvoiceItems;
        if (Object.keys(invoice.items).length > 0) {
            let res = {};
            for (var serviceKey in dict) {
                let subres = 0;
                for (var regionKey in dict[serviceKey]) {
                    if (Array.isArray(dict[serviceKey][regionKey])) {
                        const res = dict[serviceKey][regionKey].reduce(
                            (acc, current) =>
                                acc + parseFloat(current.SubAmount),
                            0
                        );
                        subres += res;
                    }
                }
                res[serviceKey] =
                    Math.round((subres + Number.EPSILON) * Math.pow(10, 2)) /
                    Math.pow(10, 2);
            }
            console.log(res);
            return res;
        } else {
            return {};
        }
    },
    getSubTotal({ invoice }, { getInvoiceItems }) {
        const dict = getInvoiceItems;
        if (Object.keys(invoice.items).length > 0) {
            let result = 0;
            for (var serviceKey in dict) {
                for (var regionKey in dict[serviceKey]) {
                    if (Array.isArray(dict[serviceKey][regionKey])) {
                        const res = dict[serviceKey][regionKey].reduce(
                            (acc, current) =>
                                acc + parseFloat(current.SubAmount),
                            0
                        );
                        result += res;
                    }
                }
            }
            return result;
        } else {
            return 0;
        }
    },
    getTotal({ invoice }, { getSubTotal, getTotalTaxes }) {
        if (invoice.items) {
            return parseFloat(getSubTotal) + parseFloat(getTotalTaxes);
        } else {
            return 0;
        }
    },
    getTotalTaxes({ invoice }) {
        if (invoice.items) {
            const dict = invoice.items;
            let result = 0;
            for (var serviceKey in dict) {
                for (var regionKey in dict[serviceKey]) {
                    if (Array.isArray(dict[serviceKey][regionKey])) {
                        result += dict[serviceKey][regionKey].reduce(
                            (acc, cur) =>
                                acc +
                                parseFloat(cur.tax / 100) *
                                    parseFloat(cur.SubAmount),
                            0
                        );
                    }
                }
            }
            return result;
        } else {
            return 0;
        }
    },
    getDiscount({ discountRate }, { getTotal }) {
        if (discountRate.total == 1) {
            return 0;
        } else {
            return (
                Math.round(
                    (parseFloat(getTotal) * (1 - discountRate.total) +
                        Number.EPSILON) *
                        Math.pow(10, 2)
                ) / Math.pow(10, 2)
            );
        }
    },
};
const mutations = {
    addInvoice(state, invoice) {
        state.invoice = { ...state.invoice, ...invoice };
    },
    addCustomer(state, customer) {
        state.customer = { ...state.customer, ...customer };
    },
    addCompany(state, company) {
        state.company = { ...state.company, ...company };
    },
    setTotalAmount(state, totalAmount) {
        state.invoice = { ...state.invoice, totalAmount };
    },
    setDiscountRate(state, discountRate) {
        state.discountRate = { ...discountRate };
    },
};
const actions = {
    addInvoice({ commit }, invoice) {
        commit('addInvoice', invoice);
    },
    addCustomer({ commit }, customer) {
        commit('addCustomer', customer);
    },
    addCompany({ commit }, company) {
        commit('addCompany', company);
    },
    setTotalAmount({ commit }, totalAmount) {
        commit('setTotalAmount', totalAmount);
    },
    setDiscountRate({ commit }, discountRate) {
        commit('setDiscountRate', discountRate);
    },
};

export default { state, getters, actions, mutations };
